import MultiEditTableFooter from './MultiEditTableFooter';

export default MultiEditTableFooter;
